import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Groups } from 'projects/access-control/src/app/Domain/Entities/group.interface';
import { updateGroup, updateSelectedGroup } from 'projects/access-control/src/app/Infrastructure/Store/groups/groups.action';
import { TranslateService } from '@mangosoft/mango-layout';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

interface SecurityTranslate {
	title: string;
	description: string;
	titlePassword: string;
	descriptionPassword: string;
	titleSms: string;
	descriptionSms: string;
	titleTotp: string;
	descriptionTotp: string;
	title2: string;
	titleMinimun: string;
	descriptionMinimun: string;
	titleCharacter: string;
	descriptionCharacter: string;
	titleValidity: string;
	descriptionValidity: string;
	titleRefresh: string;
	textRefresh: string;
	minutes: string;
	buttonEdit: string;
	buttonSave: string;
}
@Component({
	selector: 'app-security',
	templateUrl: './security.component.html',
	styleUrls: ['./security.component.scss'],
})
export class SecurityComponent implements OnInit, OnDestroy {
	@Input() group: Groups = {} as Groups;
	@Input() loading: boolean = false;

	methodPassword = '';
	isEdit = true;
	rangeValues: number = 8;
	checked: boolean = true;
	password = 5;
	val = 10;
	minutes: number = 5;
	dataTranslateSecurity: SecurityTranslate = {} as SecurityTranslate;
	subscriptionTranslate!: Subscription;
	constructor(private translateService: TranslateService, private store: Store) {}

	ngOnInit(): void {
		this.dataTranslate();
		this.methodPassword = this.group.security;
		this.rangeValues = this.group.policy.lenght_pass;
		this.checked = this.group.policy.special_chars;
		this.password = this.group.policy.validation_time;
		this.minutes = this.group.refreshToken || 4;
	}

	dataTranslate() {
		this.subscriptionTranslate = this.translateService.init('AccessControl').subscribe((data) => {
			this.dataTranslateSecurity = data.pages.groups.tabs.infoTabs.security;
		});
	}

	updateGroup() {
		if (this.isEdit) {
			this.isEdit = !this.isEdit;
		} else {
			const request: Groups = {
				...this.group,
				security: this.methodPassword,
				refreshToken: this.minutes,
				policy: {
					lenght_pass: this.rangeValues,
					special_chars: this.checked,
					validation_time: this.password,
				},
			};

			this.store.dispatch(
				updateSelectedGroup({ group: request, ids: { pk: this.group.pk, sk: this.group.sk } })
			);
			this.isEdit = !this.isEdit;
		}
	}

	ngOnDestroy(): void {
		this.subscriptionTranslate?.unsubscribe();
	}
	onChangeSecurity(value: string) {
		this.methodPassword = value;
	}
}
